import React, { useEffect, useState } from 'react';
import { langCheck } from "Pub/js/utils";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setAvatar } from "Store/appStore/action";
import HotKeysModal from 'Components/HotKeysModal';
import { cloneDeep } from 'lodash';
import Avatars from 'Pub/js/defaultAvatar';
import { setStore, getStore } from "Pub/js/storageUtils";
import AvatarEdit from './AvatarEdit';
import Ajax from "Pub/js/ajax";
import Notice from "Components/Notice";

const AvatarList = props => {
    const { closeAvatarList, json, setAvatar, avatar = "" } = props;
    const arr = [
        { url: Avatars.avatar1, select: false },
        { url: Avatars.avatar2, select: false },
        { url: Avatars.avatar3, select: false },
        { url: Avatars.avatar4, select: false },
        { url: Avatars.avatar5, select: false },
        { url: Avatars.avatar6, select: false },
        { url: Avatars.avatar7, select: false },
        { url: Avatars.avatar8, select: false },
        { url: Avatars.avatar9, select: false },
    ];
    const [avatarArray, setNewIconList] = useState(arr);
    const [imgFileObj, setImgFileObj] = useState(avatar || '');
    const [customPicture, setCustomPicture] = useState(false);

    const handleCancel = () => {
        closeAvatarList(false);
    };
    useEffect(() => {
        _arrImgToBase64().then(data => {
            let url = '';
            data.forEach(item => {
                if (item.imgBase64 === avatar) {
                    url = item.url;
                }
            });
            const newAvatarArray = cloneDeep(avatarArray);
            newAvatarArray.map(item => {
                item.select = item.url === url;
                return item;
            });
            const flag = newAvatarArray.some(item => { return item.select; });
            if (avatar) {
                setCustomPicture(!flag);
                setStore("STOREUPLOADAVATARIMG", !flag);
            } else { // 无头像
                newAvatarArray[0].select = true;
            }
            setNewIconList(newAvatarArray);
        });

    }, [avatar]);
    // 保存头像
    const handleOk = () => {
        Ajax({
            toastContainer: props.pageRef,
            url: `/nccloud/platform/userimage/operateuserimage.do`,
            data: { file: imgFileObj },
            loading: true,
            info: {
                name: langCheck(
                    "UserInfo-000000",
                    "pages",
                    json,
                ) /* 国际化处理： 账户设置*/,
                action: langCheck(
                    "UserInfo-000001",
                    "pages",
                    json,
                ), /* 国际化处理： 头像上传*/
            },
            success: ({ data: { data, success } }) => {
                if (success && data) {
                    setStore("STOREFORUSERAVATAR", imgFileObj);
                    setAvatar(imgFileObj);
                    closeAvatarList(false);
                    Notice({
                        status: "success",
                        msg: langCheck('0000PUB-000437'), //多语 - 更换头像成功
                    });
                }
            },
        });

    };

    // 选中图标
    const handleSelectIcon = e => {
        const newAvatarArray = cloneDeep(avatarArray).map(item => {
            item.select = item.url === e.url;
            return item;
        });
        setNewIconList(newAvatarArray);
        const image = new Image();
        image.src = e.url;
        image.onload = () => {
            const base64 = _getBase64Image(image);
            setImgFileObj(base64);
        };
        setCustomPicture(false);
        setStore("STOREUPLOADAVATARIMG", false);
    };
    // 头像转base64
    const _getBase64Image = img => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, img.width, img.height);
        var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
        var dataURL = canvas.toDataURL("image/" + ext);
        return dataURL;
    };
    const _arrImgToBase64 = () => {
        const newArr = cloneDeep(avatarArray);
        return new Promise(resolve => {
            const base64List = [];
            newArr.map((item => {
                const image = new Image();
                image.src = item.url;
                image.onload = () => {
                    base64List.push({ ...item, imgBase64: _getBase64Image(image) });
                    if (newArr.length === base64List.length) { resolve(base64List); }
                };
            }));
        });
    };
    const imgList = () => {
        return avatarArray.map(item => {
            const { iconName, select, url } = item;
            return (
                <div className="avatar-item" key={iconName} style={select ? { border: '1px solid #FF2121' } : {}}>
                    <div className='img-box'>
                        <img className='avatar-img' src={url} alt="" onClick={() => handleSelectIcon(item)} />
                    </div>
                    {
                        select && <img className='select-icon' src={Avatars.selectIcon} alt="" />
                    }
                </div>
            );
        });

    };
    // 取消默认头像选中效果 上传图片回调
    const uploadPicture = imgFileObj => {
        const newAvatarArray = cloneDeep(avatarArray).map(item => {
            item.select = false;
            return item;
        });
        setNewIconList(newAvatarArray);
        setImgFileObj(imgFileObj);
        setCustomPicture(true);

    };
    return (
        <HotKeysModal
            fieldid="avatar-list"
            maskClosable={false}
            destroyOnClose={true}
            visible={true}
            title={langCheck('0000PUB-000434')} /**多语 - 更换头像 */
            width={520}
            height={280}
            wrapClassName="vertical-center-modal"
            onOk={handleOk}
            onCancel={handleCancel}
        >

            <div className="avatar-list-box">
                <AvatarEdit customPicture={customPicture} uploadPicture={uploadPicture} json={json} />
                {imgList()}
            </div>
        </HotKeysModal>
    );
};

AvatarList.propTypes = { setAvatar: PropTypes.func.isRequired };

export default connect(
    state => ({ avatar: state.appData.avatar }),
    { setAvatar },
)(AvatarList);